module.exports = __webpack_public_path__ + "img/voice-icon.32727394.svg";